export default __webpack_public_path__ + "static/media/home.5f12a0ce.webp";